"use strict";

var _slicedToArray = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var DOMException = require("domexception");

var StorageEvent = require("../generated/StorageEvent");

var idlUtils = require("../generated/utils");

var _require = require("../helpers/events"),
    fireAnEvent = _require.fireAnEvent; // https://html.spec.whatwg.org/multipage/webstorage.html#the-storage-interface


var StorageImpl =
/*#__PURE__*/
function () {
  function StorageImpl(args, _ref) {
    var associatedWindow = _ref.associatedWindow,
        storageArea = _ref.storageArea,
        url = _ref.url,
        type = _ref.type,
        storageQuota = _ref.storageQuota;

    _classCallCheck(this, StorageImpl);

    this._associatedWindow = associatedWindow;
    this._items = storageArea;
    this._url = url;
    this._type = type;
    this._quota = storageQuota;
  }

  _createClass(StorageImpl, [{
    key: "_dispatchStorageEvent",
    value: function _dispatchStorageEvent(key, oldValue, newValue) {
      var _this = this;

      return this._associatedWindow._currentOriginData.windowsInSameOrigin.filter(function (target) {
        return target !== _this._associatedWindow;
      }).forEach(function (target) {
        return fireAnEvent("storage", target, StorageEvent, {
          key: key,
          oldValue: oldValue,
          newValue: newValue,
          url: _this._url,
          storageArea: target["_" + _this._type]
        });
      });
    }
  }, {
    key: "key",
    value: function key(n) {
      if (n >= this._items.size) {
        return null;
      }

      return _toConsumableArray(this._items.keys())[n];
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      if (this._items.has(key)) {
        return this._items.get(key);
      }

      return null;
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      var oldValue = this._items.get(key) || null;

      if (oldValue === value) {
        return;
      } // Concatenate all keys and values to measure their length against the quota


      var itemsTotalLength = key.length + value.length;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref4 = _step.value;

          var _ref3 = _slicedToArray(_ref4, 2);

          var curKey = _ref3[0];
          var curValue = _ref3[1];

          // If the key already exists, skip it as it will be set to the new value instead
          if (key !== curKey) {
            itemsTotalLength += curKey.length + curValue.length;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (itemsTotalLength > this._quota) {
        throw new DOMException("The ".concat(this._quota, "-code unit storage quota has been exceeded."), "QuotaExceededError");
      }

      setTimeout(this._dispatchStorageEvent.bind(this), 0, key, oldValue, value);

      this._items.set(key, value);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      if (this._items.has(key)) {
        setTimeout(this._dispatchStorageEvent.bind(this), 0, key, this._items.get(key), null);

        this._items.delete(key);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this._items.size > 0) {
        setTimeout(this._dispatchStorageEvent.bind(this), 0, null, null, null);

        this._items.clear();
      }
    }
  }, {
    key: "length",
    get: function get() {
      return this._items.size;
    }
  }, {
    key: idlUtils.supportedPropertyNames,
    get: function get() {
      return this._items.keys();
    }
  }]);

  return StorageImpl;
}();

module.exports = {
  implementation: StorageImpl
};